import React, { PureComponent, ReactNode } from 'react'
import styled from 'styled-components'

const Wrapper = styled.div`
  margin-top: 10px;
`

type TPlaceholder = {
  bsClass?: string
  children: ReactNode
}
class Placeholder extends PureComponent<TPlaceholder> {
  render(): React.ReactElement {
    return (
      <Wrapper className="text-center">
        <h3
          className={`text-${
            this.props.bsClass ? this.props.bsClass : 'muted'
          }`}
        >
          {this.props.children}
        </h3>
      </Wrapper>
    )
  }
}

export default Placeholder
